export const PAYMENT_STATUS_LIST = [
  { id: 1, name: 'paid', value: 'paid' },
  { id: 2, name: 'due', value: 'due' },
  { id: 3, name: 'past due', value: 'past due' },
  { id: 4, name: 'refunded', value: 'refunded' },
  { id: 5, name: 'due today', value: 'due today' }
];

export const DOCUMENT_TYPE_LIST = [
  { id: 1, name: 'Quote', value: 'quote' },
  { id: 2, name: 'Invoice', value: 'invoice' },
  { id: 3, name: 'Sales Order', value: 'sales' }
];
